import { createContext } from 'react';

export const OrderUpdatesContext = createContext(null);
